/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDataBin = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M7 6.6 5.7 5.3 4.3 6.7 8 10.4l3.7-3.7-1.4-1.4L9 6.6V4h8v2.6l-1.3-1.3-1.4 1.4 3.7 3.7 3.7-3.7-1.4-1.4L19 6.6V2H2v2h5zm7 5.4v10h8V12zm6 8h-4v-6h4zM4 22h8V12H4zm2-8h4v6H6z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgDataBin as DataBin };
